import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { findSensor, searchList, findSensorId, updateSensorId } from '../_actions/user_action';
import { listUser, findUser, updateUser, deleteUser, logoutAdmin } from '../_actions/user_action';
import { findSetting, updateSetting, findGateway, updateGateway, registerDevice, deleteDevice } from '../_actions/user_action';
import '../css_admin/Header.css';
import '../css_admin/Body.css';

import Button from '@mui/material/Button';
// import Alert from '@mui/material/Alert';
// import Stack from '@mui/material/Stack';

/* Pagination */
import Pagination from '@mui/material/Pagination';

/* Checkbox */
import Checkbox from '@mui/material/Checkbox';

/* Radio Group */
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

/* 폰트어썸 import */
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Modal import
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

// 주소검색 - 다음
import Post from "./Post";

// 출력
import { CSVLink } from 'react-csv';
import moment from 'moment';
import 'moment/locale/ko';
import { getAdminAccount, clearSession } from '../utils/session';

const setting = require('../config/setting');
const prefixMainSensor = setting.sensor_no_site_name + setting.sensor_no_model_number + "-" + setting.sensor_no_main_type + "-";
const prefixNodeSensor = setting.sensor_no_site_name + setting.sensor_no_model_number + "-" + setting.sensor_no_node_type + "-";
const prefixMainSensorBefore = setting.sensor_no_site_name + setting.sensor_no_model_number + "-" + "MS" + "-";

// Modal
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1080,
    bgcolor: 'background.paper',
    borderRadius: '16px',
    border: 'none',
    boxShadow: 14,
    p: 4
};

let arrayPosts = [];
let arrayPrints = [];

function RegistrationUser() {
    const dispatch = useDispatch();

    const adminAccount = getAdminAccount() || {};

    const onLogoutHandler = async (event) => {
        event.preventDefault();
        await dispatch(logoutAdmin({ email: adminAccount.email }));
        clearSession();
        window.location.replace('/');
    };

    // <!--
    // Start - 등록 리스트 및 관리  Registration list and management
    const [userListInfo, setUserListInfo] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const dataCount = setting.list_max_count;
    const LAST_PAGE = arrayPosts.length % dataCount === 0 ? parseInt(arrayPosts.length / dataCount) : parseInt(arrayPosts.length / dataCount) + 1; // 마지막 페이지
    const [page, setPage] = useState(1);

    const headers = [
        { label: "장비 Part No.", key: "pMainSensor" },
        { label: "등록일", key: "pRegistDate" },
        { label: "상호", key: "pCompany" },
        { label: "아이디", key: "pID" },
        { label: "전화번호", key: "pTel" },
        { label: "주소", key: "pAddress" },
        { label: "담당자", key: "pChargeName" },
        { label: "휴대폰 번호", key: "pCellPhone1" }
    ];
    
    useEffect(() => {
        dispatch(listUser()).then(response => {
            if (response.payload.listSuccess) {
                let userList = response.payload.userList;
                arrayPosts = userList;
                // console.log('arrayPosts', arrayPosts);
                userList.map((list, index) => {
                    let post = {
                        pMainSensor: list.sensorMain,
                        pRegistDate: list.registerDate,
                        pCompany: list.company,
                        pID: list.email,
                        pTel: list.tel,
                        pAddress: list.address,
                        pChargeName: list.chargeName,
                        pCellPhone1: list.cellPhone1
                    };
                    arrayPrints[index] = post;
                });

                if (page === LAST_PAGE) {
                    setUserListInfo(arrayPosts.slice(dataCount * (page - 1)));
                } else {
                    setUserListInfo(arrayPosts.slice(dataCount * (page - 1), dataCount * (page - 1) + dataCount));
                }
                setSelectedIndex(-1);
            }
        })
        .catch((err) => console.log(err));
    }, []);

    // Search
    const [search, setSearch] = useState({search: ""});

    const onChangeListSearch = (e) => {
        console.log(e.target.name, e.target.value);

        const { value, name } = e.target;
        setSearch({
            ...search,
            [name]: value
        });
    };

    const handleListSearch = (e) => {
        e.preventDefault();

        let body = {
            search: search.search
        };

        console.log('searchList', body);
        dispatch(searchList(body)).then(response => {
            if (response.payload.listSuccess) {
                let userList = response.payload.userList;
                arrayPosts = userList;
                console.log('arrayPosts', arrayPosts);
                userList.map((list, index) => {
                    let post = {
                        pMainSensor: list.sensorMain,
                        pRegistDate: list.registerDate,
                        pCompany: list.company,
                        pID: list.email,
                        pTel: list.tel,
                        pAddress: list.address,
                        pChargeName: list.chargeName,
                        pCellPhone1: list.cellPhone1
                    };
                    arrayPrints[index] = post;
                });

                if (page === LAST_PAGE) {
                    setUserListInfo(arrayPosts.slice(dataCount * (page - 1)));
                } else {
                    setUserListInfo(arrayPosts.slice(dataCount * (page - 1), dataCount * (page - 1) + dataCount));
                }
                setSelectedIndex(-1);
            } else {
                alert(response.payload.message);
            }
        });
    };

    // 선택
    const [checkedList, setCheckedLists] = useState([]);
    const onCheckedElement = (checked, list, index) => {
        // alert(checked);

        if (checked) {
            setCheckedLists([...checkedList, list]);
            setSelectedIndex(index);
        } else {
            // 체크 해제된 항목만 제거
            setCheckedLists(prev => prev.filter(item => item !== list));
            // 선택 인덱스가 해제된 항목과 같다면 초기화
            setSelectedIndex(prevIdx => prevIdx === index ? -1 : prevIdx);
        }
    };
    // End - 등록 리스트 및 관리  Registration list and management

    // 등록 리스트 및 관리
    const focusRefModifyMainSensor = useRef();
    const focusRefModifyNodeSensor = useRef();
    const focusRefModifyNodeSensorId = useRef();
    const focusRefModifyLifetimeNH3 = useRef();
    const focusRefModifyLifetimeH2S = useRef();
    const focusRefModifyLifetimeTH = useRef();
    const focusRefModifyUserIdEmail = useRef();
    const focusRefModifyUserPassword = useRef();
    const focusRefModifyUserPasswordConfirm = useRef();
    const focusRefModifyUserCompany = useRef();
    const focusRefModifyUserTel = useRef();
    const focusRefModifyUserAddress = useRef();
    const focusRefModifyUserAddressDetail = useRef();
    const focusRefModifyUserChargeName = useRef();
    const focusRefModifyUserCellPhone1 = useRef();
    const focusRefModifyUserCellPhone2 = useRef();

    const [inputsModify, setInputsModify] = useState({
        modifyMainSensor: prefixMainSensor,
        modifyNodeSensor: [],
        modifyNodeSensorId: [],
        modifyUnitNH3: "0",
        modifyUnitH2S: "0",
        modifyUnitTemperature: "0",
        modifyLifetimeNH3: "",
        modifyLifetimeH2S: "",
        modifyLifetimeTH: "",
        modifyUserIdEmail: "",
        modifyUserPassword: "",
        modifyUserPasswordConfirm: "",
        modifyUserCompany: "",
        modifyUserTel: "",
        modifyUserAddress: "",
        modifyUserAddressDetail: "",
        modifyUserPostal: "",
        modifyUserLatitude: "",
        modifyUserLongitude: "",
        modifyUserChargeName: "",
        modifyUserCellPhone1: "",
        modifyUserCellPhone2: ""
    });

    const {
        modifyMainSensor,
        modifyNodeSensor,
        modifyNodeSensorId,
        modifyUnitNH3,
        modifyUnitH2S,
        modifyUnitTemperature,
        modifyLifetimeNH3,
        modifyLifetimeH2S,
        modifyLifetimeTH,
        modifyUserIdEmail,
        modifyUserPassword,
        modifyUserPasswordConfirm,
        modifyUserCompany,
        modifyUserTel,
        modifyUserAddress,
        modifyUserAddressDetail,
        modifyUserChargeName,
        modifyUserCellPhone1,
        modifyUserCellPhone2
    } = inputsModify;
            
    const handleChangeModify = (e) => {
        console.log(e.target.name, e.target.value);

        // let regex = /^[0-9]+$/;
        // if (e.target.name === 'modifyLifetimeNH3' || e.target.name === 'modifyLifetimeH2S' || e.target.name === 'modifyLifetimeTH') {
        //     if (!regex.test(e.target.value))
        //         return;
        // }
        let regex = /^[0-9]*$/; // '*'를 사용하여 빈 문자열 허용
        if (['registerLifetimeNH3', 'registerLifetimeH2S', 'registerLifetimeTH'].includes(e.target.name)) {
            if (!regex.test(e.target.value)) return;
        }
        regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'modifyUserTel') {
            if (!regex.test(e.target.value))
                return;
        }
        regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'modifyUserCellPhone1' || e.target.name === 'modifyUserCellPhone2') {
            if (!regex.test(e.target.value))
                return;
        }

        const { value, name } = e.target;
        setInputsModify({
            ...inputsModify,
            [name]: value
        });
    };
    
    let alert_msg = "";

    // 수정 Modal
    const [modifyOpen, setModifyOpen] = useState(false);
    const handleModifyOpen = (e) => {
        // alert(checkedList.length);
        // alert(selectedIndex);

        if (selectedIndex < 0) {
            alert_msg = "등록 리스트 페이지를 다시 로드해 주세요";
        }

        if (checkedList.length === 0) {
            alert_msg = "등록 리스트를 선택해주세요";
        } else if (checkedList.length !== 1) {
            alert_msg = "등록 리스트 중 하나만 선택해주세요";
        }
        if (alert_msg.length > 1) {
            alert(alert_msg);
            return;
        }

        let body = {
            id: userListInfo[selectedIndex].email,
            sensorMain: userListInfo[selectedIndex].sensorMain
        };

        console.log('findSetting', body)
        dispatch(findSetting(body)).then(response => {
            if (response.payload.findSuccess) {
                let settingInfo = response.payload.settingInfo;
                console.log(settingInfo);

                setEnroll_address({
                    ...enroll_address,
                    address: userListInfo[selectedIndex].address,
                    postal: userListInfo[selectedIndex].postal,
                    latitude: userListInfo[selectedIndex].latitude,
                    longitude: userListInfo[selectedIndex].longitude
                });

                let sensorNode = userListInfo[selectedIndex].sensorNode;
                console.log('sensorNode: ', sensorNode);
                // sensorNode.map((sensor) => {
                //     let node = {
                //         id: sensor.id,
                //         value: sensor.value,
                //         device: sensor.device
                //     };
                //     setInputItems([...inputItems, node]);
                // });
                setInputItems([])
                setInputItems((prevItems) => [
                    ...prevItems,
                    ...sensorNode.map(sensor => ({
                        id: sensor.id,
                        value: sensor.value,
                        device: sensor.device
                    }))
                ]);
                console.log('inputItems: ', inputItems);
                nextID.current = inputItems.length;
                
                setInputsModify({
                    modifyMainSensor: userListInfo[selectedIndex].sensorMain,
                    modifyNodeSensor: userListInfo[selectedIndex].sensorNode,
                    modifyUnitNH3: settingInfo.unitNH3.toString(),
                    modifyUnitH2S: settingInfo.unitH2S.toString(),
                    modifyUnitTemperature: settingInfo.unitT.toString(),
                    modifyLifetimeNH3: settingInfo.lifetimeNH3.toString(),
                    modifyLifetimeH2S: settingInfo.lifetimeH2S.toString(),
                    modifyLifetimeTH: settingInfo.lifetimeTH.toString(),
                    modifyUserIdEmail: userListInfo[selectedIndex].email,
                    modifyUserPassword: "", // userListInfo[selectedIndex].password,
                    modifyUserPasswordConfirm: "", // userListInfo[selectedIndex].password,
                    modifyUserCompany: userListInfo[selectedIndex].company,
                    modifyUserTel: userListInfo[selectedIndex].tel,
                    modifyUserAddress: userListInfo[selectedIndex].address,
                    modifyUserAddressDetail: userListInfo[selectedIndex].addressDetail,
                    modifyUserPostal: userListInfo[selectedIndex].postal,
                    modifyUserLatitude: userListInfo[selectedIndex].latitude,
                    modifyUserLongitude: userListInfo[selectedIndex].longitude,
                    modifyUserChargeName: userListInfo[selectedIndex].chargeName,
                    modifyUserCellPhone1: userListInfo[selectedIndex].cellPhone1,
                    modifyUserCellPhone2: userListInfo[selectedIndex].cellPhone2
                });

                setModifyOpen(true);
            }
        });
    };

    // useEffect를 이용해 inputItems 변경 사항을 감지하여 로그 출력
    useEffect(() => {
        if (inputItems.length > 0) {
            console.log('Updated inputItems: ', inputItems);
        }
    }, [modifyOpen]);

    const handleModifyClose = (targetIndex) => {
        setSelectedIndex(targetIndex);
        setModifyOpen(false);
    }

    const [showModifyPassword, setShowModifyPassword] = useState(false);
    const handleClickShowModifyPassword = () => setShowModifyPassword((show) => !show);
    const handleMouseDownModifyPassword = (event) => {
      event.preventDefault();
    };

    const [showModifyPasswordConfirm, setShowModifyPasswordConfirm] = useState(false);
    const handleClickShowModifyPasswordConfirm = () => setShowModifyPasswordConfirm((show) => !show);
    const handleMouseDownModifyPasswordConfirm = (event) => {
      event.preventDefault();
    };

    // 장비 Part No. Gateway 중복확인
    const [checkDuplicate, setCheckDuplicate] = useState(false);
    const [existMainSensor, setExistMainSensor] = useState(false);

    const handleCheckDuplicate = (e) => {
        e.preventDefault();
        
        setCheckDuplicate(false);
        setExistMainSensor(false);

        let check_error = "";

        if (modifyMainSensor.length === 0 || modifyMainSensor === undefined) {
            check_error = "[장비 Part No. - Gateway]를 입력해주세요.";
            alert(check_error);
            focusRefModifyMainSensor.current.focus();
            return;
        }

        if (modifyMainSensor.length !== setting.sensor_no_total_length) {
            alert(modifyMainSensor);

            check_error = "[장비 Part No. - Gateway] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(check_error);
            setInputsModify({
                ...inputsModify,
                modifyMainSensor: prefixMainSensor
            });
            focusRefModifyMainSensor.current.focus();
            return;
        }

        // console.log(modifyMainSensor.indexOf(prefixMainSensor));
        if (modifyMainSensor.indexOf(prefixMainSensor) < 0) {
            if (modifyMainSensor.indexOf(prefixMainSensorBefore) < 0) {
                check_error = "[장비 Part No. - Gateway] 명명 규칙에 따라 올바르게 입력해주세요.";
                alert(check_error);
                setInputsModify({
                    ...inputsModify,
                    modifyMainSensor: prefixMainSensor
                });
                focusRefModifyMainSensor.current.focus();
                return;
            }
        }

        const tempSensor = modifyMainSensor;
        const tempNumber = tempSensor.substring(tempSensor.length - setting.sensor_no_product_number);
        const productNumber = Number(tempNumber);

        if (productNumber < 1 || productNumber > 999999) {
            check_error = "[000001 ~ 999999] 사이의 제품순번을 입력해주세요.";
            alert(check_error);
            setInputsModify({
                ...inputsModify,
                modifyMainSensor: prefixMainSensor
            });
            focusRefModifyMainSensor.current.focus();
            return;
        }

        let body = {
            sensor: modifyMainSensor
        };

        console.log('findSensor', body);
        dispatch(findSensor(body)).then(response => {
            console.log(response);
            setCheckDuplicate(true);
            if (response.payload.findSuccess) {
                if (response.payload.deviceInfo) {
                    setExistMainSensor(true);
                }
            } else {
                const inputItemsCopy = JSON.parse(JSON.stringify(inputItems));
                inputItemsCopy[0].value = prefixNodeSensor;
                setInputItems(inputItemsCopy);
            }
        })
        .catch((err) => console.log(err));
    };

    // 장비 Part No. Node Sensor + 추가 / - 삭제
    const nextID = useRef(1);
    const [inputItems, setInputItems] = useState([{id: 0, value: '', device: ''}]);

    const addInput = (e) => {
        e.preventDefault();

        let add_error = "";

        // if (!checkDuplicate) {
        //     add_error = "[Gateway] 입력 후 [중복확인]을 먼저 진행하세요.";
        //     alert(add_error);
        //     focusRefModifyMainSensor.current.focus();
        //     return;
        // }

        // if (existMainSensor) {
        //     add_error = "[Gateway] 동일한 장비 Part No.입니다. [중복확인]을 다시 진행하세요.";
        //     alert(add_error);
        //     focusRefModifyMainSensor.current.focus();
        //     return;
        // }

        console.log('addInput inputItems: ', inputItems);

        if (inputItems[nextID.current - 1].value.length === 0 || inputItems[nextID.current - 1].value === undefined) {
            add_error = "[Node Sensor]를 입력해주세요.";
            alert(add_error);
            focusRefModifyNodeSensor.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].value.length !== setting.sensor_no_total_length) {
            add_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(add_error);
            focusRefModifyNodeSensor.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].value.indexOf(prefixNodeSensor) < 0) {
            add_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(add_error);
            focusRefModifyNodeSensor.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].device.length === 0 || inputItems[nextID.current - 1].device === undefined) {
            add_error = "[Node Sensor Device ID]를 입력해주세요.";
            alert(add_error);
            focusRefModifyNodeSensorId.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].device.length !== setting.sensor_no_total_length + 1) {
            add_error = "[Node Sensor Device ID]는 영.숫자 조합 16자 입니다.";
            alert(add_error);
            focusRefModifyNodeSensorId.current.focus();
            return;
        }

        if (nextID.current + 1 > setting.sensor_no_node_max_count) {
            add_error = "[Node Sensor] 추가 최대 갯수입니다.";
            alert(add_error);
            return;
        }

        const tempDevice = inputItems[nextID.current - 1].device;
        console.log('tempDevice: ', tempDevice);
        console.log('modifyNodeSensorId: ', modifyNodeSensorId);
        if (tempDevice === modifyNodeSensorId) {
            add_error = "[Node Sensor] 동일한 장비 Device ID 입니다. 한번 더 확인해주세요.";
            alert(add_error);
            return;
        }
        const isDuplicateDevice = inputItems.some((item, index) => {
            if (index === nextID.current - 1) return false;
            return item.device === tempDevice;
        });
        if (isDuplicateDevice) {
            add_error = "[Node Sensor] 동일한 장비 Device ID 입니다. 한번 더 확인해주세요.";
            alert(add_error);
            return;
        }

        const tempNumber = tempSensor.substring(tempSensor.length - setting.sensor_no_product_number);
        let productNumber = Number(tempNumber);
        if (productNumber < 1 || productNumber > 999999) {
            add_error = "[000001 ~ 999999] 사이의 제품순번을 입력해주세요.";
            alert(add_error);
            focusRefModifyNodeSensor.current.focus();
            return;
        }
        
        const tempSensor = inputItems[nextID.current - 1].value;
        let body = {
            sensor: tempSensor
        };

        console.log('findSensor', body);
        dispatch(findSensor(body)).then(response => {
            // console.log(response);
            if (response.payload.findSuccess) {
                if (response.payload.deviceInfo) {
                    add_error = "[Node Sensor] 동일한 장비 Part No.입니다. 한번 더 확인해주세요.";
                    alert(add_error);
                    return;
                }
            } else {
                productNumber += 1;

                const nextNumber = "000000" + productNumber.toString();
                const nextNodeSensor = prefixNodeSensor + nextNumber.substring(nextNumber.length - setting.sensor_no_product_number);
        
                let input = {
                    id: nextID.current,
                    value: nextNodeSensor,
                    device: ''
                };
                console.log('addInput', input);
                
                setInputItems([...inputItems, input]);
                // setModifyNodeSensor([...modifyNodeSensor, input]);
                nextID.current += 1;
            }
        });
    };

    const deleteInput = (index) => {
        console.log('index', index, 'inputItems length', inputItems.length);
        if (index < inputItems.length - 1) return;

        setInputItems(inputItems.filter(item => item.id !== index));
        // setModifyNodeSensor(modifyNodeSensor.filter(item => item.id !== index));
        nextID.current -= 1;
    };

    const handleChangeNodeSensor = (e, index) => {
        if (index > inputItems.length) return;

        const inputItemsCopy = JSON.parse(JSON.stringify(inputItems));
        // console.log('handleChangeNodeSensor', inputItemsCopy);
        inputItemsCopy[index].value = e.target.value;
        setInputItems(inputItemsCopy);
    };

    const handleChangeNodeSensorId = (e, index) => {
        if (index > inputItems.length) return;

        const inputItemsCopy = JSON.parse(JSON.stringify(inputItems));
        // console.log('handleChangeNodeSensor', inputItemsCopy);
        inputItemsCopy[index].device = e.target.value;
        setInputItems(inputItemsCopy);
    
        const { value, name } = e.target;
        console.log(name, value);
        setInputsModify({
            ...inputsModify,
            [name]: value
        });
    };

    // 주소검색
    const [enroll_address, setEnroll_address] = useState({
        address: '',
        postal: '',
        latitude: '',
        longitude: ''
    });

    const [popup, setPopup] = useState(false);

    const handleInput = (e) => {
        setEnroll_address({
            ...enroll_address,
            [e.target.name]: e.target.value
        });
    };

    const handleComplete = (data) => {
        setPopup(!popup);
        console.log('handleComplete', data);
    };

    const handleModifySubmit = (e) => {
        e.preventDefault();
        
        let modify_key = "";
        let modify_errors = "";

        // 장비 Part No. - Gateway
        // if (!checkDuplicate) {
        //     modify_errors = "[Gateway] 입력 후 [중복확인]을 먼저 진행하세요.";
        //     alert(modify_errors);
        //     focusRefModifyMainSensor.current.focus();
        //     return;
        // }

        // 장비 Part No. - Node Sensor
        if (inputItems.length === 1) {
            if (inputItems[0].value.length === 0 || inputItems[0].value === undefined) {
                modify_errors = "[Node Sensor]를 입력해주세요.";
                alert(modify_errors);
                focusRefModifyNodeSensor.current.focus();
                return;
            }

            if (inputItems[0].value.length !== setting.sensor_no_total_length) {
                modify_errors = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
                alert(modify_errors);
                focusRefModifyNodeSensor.current.focus();
                return;
            }
    
            if (inputItems[0].value.indexOf(prefixNodeSensor) < 0) {
                modify_errors = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
                alert(modify_errors);
                focusRefModifyNodeSensor.current.focus();
                return;
            }
        }

        const changeUser = {
            sensorMain: modifyMainSensor,
            sensorNode: inputItems, // modifyNodeSensor,
            unitNH3: modifyUnitNH3,
            unitH2S: modifyUnitH2S,
            unitT: modifyUnitTemperature,
            lifetimeNH3: modifyLifetimeNH3,
            lifetimeH2S: modifyLifetimeH2S,
            lifetimeTH: modifyLifetimeTH,
            email: modifyUserIdEmail,
            password: modifyUserPassword,
            passwordConfirm: modifyUserPasswordConfirm,
            company: modifyUserCompany,
            tel: modifyUserTel,
            address: enroll_address.address, // modifyUserAddress,
            addressDetail: modifyUserAddressDetail,
            chargeName: modifyUserChargeName,
            cellPhone1: modifyUserCellPhone1,
            cellPhone2: modifyUserCellPhone2
        };

        for (var key in changeUser) {
            modify_errors = "";

            if (changeUser[key].length === 0 || changeUser[key] === undefined) {
                modify_key = key;

                if (key === 'sensorMain') {
                    modify_errors = "[장비 Part No. - Gateway]가 없습니다.";
                } else if (key === 'sensorNode') {
                    modify_errors = "[장비 Part No. - Node Sensor]가 없습니다.";
                } else if (key === 'unitNH3') {
                    modify_errors = "[측정 단위 - 암모니아]가 없습니다.";
                } else if (key === 'unitH2S') {
                    modify_errors = "[측정 단위 - 황화수소]가 없습니다.";
                } else if (key === 'unitT') {
                    modify_errors = "[측정 단위 - 온도]가 없습니다.";
                } else if (key === 'lifeTimeNH3') {
                    modify_errors = "[센서 수명 - 암모니아]가 없습니다.";
                } else if (key === 'lifeTimeH2S') {
                    modify_errors = "[센서 수명 - 황화수소]가 없습니다.";
                } else if (key === 'lifeTimeTH') {
                    modify_errors = "[센서 수명 - 온/습도]가 없습니다.";
                } else if (key === 'email') {
                    modify_errors = "[아이디]가 없습니다.";
                } else if (key === 'password') {
                    modify_errors = "[비밀번호]가 없습니다.";
                } else if (key === 'passwordConfirm') {
                    modify_errors = "[비밀번호 확인]이 없습니다."
                } else if (key === 'company') {
                    modify_errors = "[상호]가 없습니다.";
                } else if (key === 'tel') {
                    modify_errors = "[전화번호]가 없습니다.";
                } else if (key === 'address') {
                    modify_errors = "[주소]가 없습니다. [주소검색]을 이용하여 입력해주세요.";
                } else if (key === 'chargeName') {
                    modify_errors = "[담당자]가 없습니다.";
                } else if (key === 'cellPhone1') {
                    modify_errors = "[휴대폰 1]이 없습니다.";
                } else if (key === 'cellPhone2') {
                    // modify_errors = "[휴대폰 2]가 없습니다."; // 휴대폰 1만 입력해도 된다.
                }
            }

            if (modify_errors.length > 1)
                break;
        }

        if (modify_errors.length > 1) {
            alert(modify_errors);

            if (modify_key === 'sensorMain') {
                focusRefModifyMainSensor.current.focus();
            } else if (modify_key === 'sensorNode') {
                focusRefModifyNodeSensor.current.focus();
            } else if (modify_key === 'lifeTimeNH3') {
                focusRefModifyLifetimeNH3.current.focus();
            } else if (modify_key === 'lifeTimeH2S') {
                focusRefModifyLifetimeH2S.current.focus();
            } else if (modify_key === 'lifeTimeTH') {
                focusRefModifyLifetimeTH.current.focus();
            } else if (modify_key === 'email') {
                focusRefModifyUserIdEmail.current.focus();
            } else if (modify_key === 'password') {
                focusRefModifyUserPassword.current.focus();
            } else if (modify_key === 'passwordConfirm') {
                focusRefModifyUserPasswordConfirm.current.focus();
            } else if (modify_key === 'company') {
                focusRefModifyUserCompany.current.focus();
            } else if (modify_key === 'tel') {
                focusRefModifyUserTel.current.focus();
            } else if (modify_key === 'address') {
                focusRefModifyUserAddress.current.focus();
            } else if (modify_key === 'chargeName') {
                focusRefModifyUserChargeName.current.focus();
            } else if (modify_key === 'cellPhone1') {
                focusRefModifyUserCellPhone1.current.focus();
            }

            return;
        }

        // 센서 수명 - 암모니아
        if (Number(modifyLifetimeNH3) < 1) {
            modify_errors = "암모니아 센서 수명은 1개월 이상 입력해주세요.";
            alert(modify_errors);
            setInputsModify({
                ...inputsModify,
                modifyLifeTimeNH3: ""
            });
            focusRefModifyLifetimeNH3.current.focus();
            return;
        }
        // 센서 수명 - 황화수소
        if (Number(modifyLifetimeH2S) < 1) {
            modify_errors = "황화수소 센서 수명은 1개월 이상 입력해주세요.";
            alert(modify_errors);
            setInputsModify({
                ...inputsModify,
                modifyLifeTimeH2S: ""
            });
            focusRefModifyLifetimeH2S.current.focus();
            return;
        }
        // 센서 수명 - 온/습도
        if (Number(modifyLifetimeTH) < 1) {
            modify_errors = "온/습도 센서 수명은 1개월 이상 입력해주세요.";
            alert(modify_errors);
            setInputsModify({
                ...inputsModify,
                modifyLifeTimeTH: ""
            });
            focusRefModifyLifetimeTH.current.focus();
            return;
        }

        // 아이디
        const emailRegex =
        /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!emailRegex.test(modifyUserIdEmail)) {
            modify_errors = "올바른 아이디(이메일)을 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserIdEmail.current.focus();
            return;
        }
  
        // 비밀번호
        const passwordRegex =
        /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
        if (!passwordRegex.test(modifyUserPassword)) {
            modify_errors = "영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserPassword.current.focus();
            return;
        }

        // 비밀번호 확인
        if (modifyUserPassword !== modifyUserPasswordConfirm) {
            modify_errors = "비밀번호가 틀려요. 다시 확인해주세요.";
            alert(modify_errors);
            setInputsModify({
                ...inputsModify,
                modifyUserPasswordConfirm: ""
            });
            focusRefModifyUserPasswordConfirm.current.focus();
            return;
        }
  
        // 상호
        if (modifyUserCompany.length < 2 || modifyUserCompany.length > 30) {
            modify_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserCompany.current.focus();
            return;
        }

        // 전화번호

        // 주소

        // 담당자
        if (modifyUserChargeName.length < 2 || modifyUserChargeName.length > 30) {
            modify_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserChargeName.current.focus();
            return;
        }

        // 휴대폰 1

        // 휴대폰 2

        let body = {
            email: modifyUserIdEmail,
            password: modifyUserPassword,
            company: modifyUserCompany,
            tel: modifyUserTel,
            address: enroll_address.address,
            addressDetail: modifyUserAddressDetail,
            postal: enroll_address.postal,
            latitude: enroll_address.latitude,
            longitude: enroll_address.longitude,
            chargeName: modifyUserChargeName,
            cellPhone1: modifyUserCellPhone1,
            cellPhone2: modifyUserCellPhone2,
            sensorMain: modifyMainSensor,
            sensorNode: modifyNodeSensor
        };

        let modify_msg = "";

        console.log('findUser', body);
        dispatch(findUser(body)).then(response => {
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                if (userInfo.accountActive === "Y") {
                    console.log('updateUser', body);
                    dispatch(updateUser(body)).then(response => {
                        if (response.payload.updateSuccess) {
                            body = {
                                id: modifyUserIdEmail,
                                sensorMain: modifyMainSensor,
                                unitNH3: Number(modifyUnitNH3),
                                unitH2S: Number(modifyUnitH2S),
                                unitT: Number(modifyUnitTemperature),
                                lifetimeNH3: Number(modifyLifetimeNH3),
                                lifetimeH2S: Number(modifyLifetimeH2S),
                                lifetimeTH: Number(modifyLifetimeTH)
                            };
                            console.log('findSetting', body);
                            dispatch(findSetting(body)).then(response => {
                                if (response.payload.findSuccess) {
                                    console.log('updateSetting', body);
                                    dispatch(updateSetting(body)).then(response => {
                                        if (response.payload.updateSuccess) {
                                            modify_msg = "[" + modifyUserIdEmail + " (" + modifyUserCompany + ")] 사용자 정보수정 되었습니다.";
                                            alert(modify_msg);
                                            window.location.replace('/RegistrationUser');
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        });
    };

    const handleDeleteSubmit = () => {
        if (checkedList.length === 0) {
            alert_msg = "삭제할 등록 리스트를 선택해주세요";
        }
        if (alert_msg.length > 1) {
            alert(alert_msg);
            return;
        }

        let message = "선택한 등록 리스트를 삭제하시겠습니까?";
        if (!window.confirm(message))
            return;
        
        let delete_msg = "";
        let delete_count = 0;

        checkedList.map((user) => {
            let body = {
                email: user.email
            };
            dispatch(deleteUser(body)).then(response => {
                if (response.payload.deleteSuccess) {                    
                    delete_count += 1;
                    if (delete_count >= checkedList.length) {
                        delete_msg = "선택한 등록 리스트를 모두 삭제하였습니다.";
                        alert(delete_msg);
                        window.location.replace('/RegistrationUser');
                    }
                }
            });
        });
    };

    const handlePrintSubmit = () => {
        let message = "";

        if (checkedList.length === 0) {
            message = "전체 등록 리스트를 출력하시겠습니까?";
            // if (!window.confirm(message))
                // return;
        }
    };

    const onPageHandler = (event, value) => {
        console.log("onPageHandler event.target.outerText", event.target.outerText);
        const nowPageInt = parseInt(event.target.outerText);
        console.log("nowPageInt", nowPageInt);
        setPage(nowPageInt);
        // console.log("onPageHandler value", value);
        // setPage(value);

        if (page === LAST_PAGE) {
            setUserListInfo(arrayPosts.slice(dataCount * (page - 1)));
        } else {
            setUserListInfo(arrayPosts.slice(dataCount * (page - 1), dataCount * (page - 1) + dataCount));
        }
    };

    const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, content: "" });

    const handleMouseMove = (e, content) => {
        setTooltip({
            visible: true,
            x: e.pageX + 15, // 마우스 오른쪽으로 15px
            y: e.pageY + 15, // 마우스 아래로 15px
            content: content,
        });
    };

    const handleMouseLeave = () => {
        setTooltip({ visible: false, x: 0, y: 0, content: "" });
    };

    const handleUpdateSensorId = (currentIndex) => {
        console.log('currentIndex: ', currentIndex);
        console.log('inputItems: ', inputItems);

        let check_error = "";

        const targetSensor = inputItems[currentIndex].value;
        const targetSensorId = inputItems[currentIndex].device;
        console.log('targetSensorId: ', targetSensorId);

        let body = {
            sensorId: targetSensorId
        };

        if (targetSensorId !== '') {
            if (targetSensorId.length !== setting.sensor_no_total_length + 1) {
                check_error = "[Node Sensor] Device ID는 영.숫자 조합 16자 입니다.";
                alert(check_error);
                focusRefModifyNodeSensorId.current.focus();
                return;
            }

            const isDuplicateDevice = inputItems.some((item, index) => {
                if (index === currentIndex) return false;
                return item.device === targetSensorId;
            });

            if (isDuplicateDevice) {
                check_error = "[Node Sensor] 동일한 장비 Device ID 입니다. 한번 더 확인해주세요.";
                alert(check_error);
                focusRefModifyNodeSensorId.current.focus();
                return;
            }

            dispatch(findSensorId(body)).then(response => {
                console.log(response);
                if (response.payload.findSuccess) {
                    check_error = "[Node Sensor] 동일한 장비 Device ID가 이미 사용중입니다. 한번 더 확인해주세요.";
                    alert(check_error);
                    return;
                } else {
                    body = {
                        id: modifyUserIdEmail,
                        sensorNumber: targetSensor,
                        sensorId: targetSensorId,
                        sensorNode: inputItems
                    };
        
                    console.log('updateSensorId: ', body);
                    dispatch(updateSensorId(body)).then(response => {
                        if (response.payload.updateSuccess) {
                            check_error = "[" + modifyUserIdEmail + " (" + targetSensorId + ")] Device ID 수정 되었습니다.";
                            alert(check_error);
                            window.location.replace('/RegistrationUser');
                        }
                    });        
                }
            });
        } else {
            body = {
                id: modifyUserIdEmail,
                sensorNumber: targetSensor,
                sensorId: targetSensorId,
                sensorNode: inputItems
            };

            console.log('updateSensorId: ', body);
            dispatch(updateSensorId(body)).then(response => {
                if (response.payload.updateSuccess) {
                    check_error = "[" + modifyUserIdEmail + "] Device ID 수정 되었습니다.";
                    alert(check_error);
                    window.location.replace('/RegistrationUser');
                }
            });
        }
    };

    const focusRefGateway = useRef();
    const focusRefAddNodeSensorNumber = useRef();
    const focusRefAddNodeSensorId = useRef();

    const [addNodeSensorNumber, setAddNodeSensorNumber] = useState('');
    const [addNodeSensorId, setAddNodeSensorId] = useState('');
    const [checkNodeDuplicate, setCheckNodeDuplicate] = useState(false);

    // Node Sensor [+] 추가 Modal
    const [addNodeSensorOpen, setAddNodeSensorOpen] = useState(false);
    const [selectedGateway, setSelectedGateway] = useState('');

    const handleAddNodeSensorOpen = (e) => {
        if (selectedIndex < 0) {
            alert_msg = "등록 리스트 페이지를 다시 로드해 주세요";
        }

        if (checkedList.length === 0) {
            alert_msg = "등록 리스트를 선택해주세요";
        } else if (checkedList.length !== 1) {
            alert_msg = "등록 리스트 중 하나만 선택해주세요";
        }
        if (alert_msg.length > 1) {
            alert(alert_msg);
            return;
        }

        const userInfo = userListInfo[selectedIndex];
        console.log('handleAddNodeSensorOpen:', userInfo);
        setSelectedGateway(userInfo.sensorMain);
        setAddNodeSensorNumber(prefixNodeSensor);
        setAddNodeSensorId('');
        setAddNodeSensorOpen(true);
    };
    const handleAddNodeSensorClose = () => setAddNodeSensorOpen(false);

    const handleGatewayChange = (event) => {
        // alert(event.target.value);
        setSelectedGateway(event.target.value);
    };

    const handleChangeAddNodeSensorNumber = (event) => {
        setAddNodeSensorNumber(event.target.value);
    };

    const handleChangeAddNodeSensorId = (event) => {
        setAddNodeSensorId(event.target.value);
    };

    const handleCheckNodeDuplicate = (e) => {
        e.preventDefault();
        
        setCheckNodeDuplicate(false);

        let check_error = "";

        if (selectedGateway.length === 0 || selectedGateway === undefined) {
            check_error = "[Gateway]를 선택해주세요.";
            alert(check_error);
            focusRefGateway.current.focus();
            return;
        }

        if (selectedGateway.indexOf(prefixMainSensor) < 0) {
            check_error = "[Gateway]를 선택해주세요.";
            alert(check_error);
            focusRefGateway.current.focus();
            return;
        }

        if (addNodeSensorNumber.length === 0 || addNodeSensorNumber === undefined) {
            check_error = "[Node Sensor]를 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        if (addNodeSensorNumber.indexOf(prefixNodeSensor) < 0) {
            check_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        if (addNodeSensorNumber.length !== setting.sensor_no_total_length) {
            check_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        const tempSensor = addNodeSensorNumber;
        const tempNumber = tempSensor.substring(tempSensor.length - setting.sensor_no_product_number);
        const productNumber = Number(tempNumber);

        if (productNumber < 1 || productNumber > 999999) {
            check_error = "[000001 ~ 999999] 사이의 제품순번을 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        if (addNodeSensorId.length === 0 || addNodeSensorId === undefined) {
            check_error = "[Node Sensor] Serial Number를 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorId.current.focus();
            return;
        }

        if (addNodeSensorId.length !== setting.sensor_no_total_length + 1) {
            check_error = "[Node Sensor] Serial Number는 영.숫자 조합 16자 입니다.";
            alert(check_error);
            focusRefAddNodeSensorId.current.focus();
            return;
        }

        const alphaNumRegex = /^[a-z0-9]+$/;
        if (!alphaNumRegex.test(addNodeSensorId)) {
            check_error = "[Node Sensor] Serial Number는 영문자(a–z)와 숫자(0–9)로만 구성되어야 합니다.";
            alert(check_error);
            focusRefAddNodeSensorId.current.focus();
            return;
        }

        let body = {
            sensor: addNodeSensorNumber
        };

        console.log('findSensor', body);
        dispatch(findSensor(body)).then(response => {
            console.log(response);
            if (response.payload.findSuccess) {
                if (response.payload.deviceInfo) {
                    check_error = "[Node Sensor] 이미 해당 제품순번이 존재합니다.";
                    alert(check_error);
                    focusRefAddNodeSensorNumber.current.focus();
                    return;
                }
            } else {
                body = {
                    sensorId: addNodeSensorId
                };

                console.log('findSensorId', body);
                dispatch(findSensorId(body)).then(response => {
                    console.log(response);
                    if (response.payload.findSuccess) {
                        check_error = "[Node Sensor] Serial Number가 이미 사용중입니다. 한번 더 확인해주세요.";
                        alert(check_error);
                        focusRefAddNodeSensorId.current.focus();
                        return;
                    } else {
                        check_error = "[Node Sensor] 추가를 위한 모든 정보 입력이 완료되었습니다.";
                        alert(check_error);
                        setCheckNodeDuplicate(true);
                    }
                });
            }
        })
        .catch((err) => console.log(err));
    };

    const handleAddNodeSensor = (e) => {
        let add_msg = "";

        if (!checkNodeDuplicate) {
            add_msg = "[Gateway] 선택 및 [Node Sensor] 정보 입력 후 [중복확인]을 먼저 진행하세요.";
            alert(add_msg);
            focusRefGateway.current.focus();
            return;
        }

        const confirmAdd = window.confirm("정말로 [Node Sensor]를 추가하시겠습니까?");
        if (confirmAdd) {
            // 사용자가 'Yes'를 클릭한 경우, 추가 작업을 진행
            let body = {
                gateway: selectedGateway
            };

            console.log('findGateway', body);
            dispatch(findGateway(body)).then(response => {
                console.log(response);
                if (response.payload.findSuccess) {
                    let gateway = response.payload.userInfo;
                    let sensorNode = gateway.sensorNode;
                    console.log('sensorNode:', sensorNode);
                    const newSensorNode = {
                        id: sensorNode.length,
                        value: addNodeSensorNumber,
                        device: addNodeSensorId
                    };
                    sensorNode.push(newSensorNode);
                    console.log('newSensorNode:', sensorNode);

                    body = {
                        gateway: selectedGateway,
                        sensorNode: sensorNode
                    };

                    dispatch(updateGateway(body)).then(response => {
                        if (response.payload.updateSuccess) {
                            body = {
                                id: gateway.email,
                                sensorNumber: addNodeSensorNumber,
                                sensorId: addNodeSensorId,
                                willChangeDateNH3: f_willChangeDate(Number(setting.sensor_lifetime_nh3)),
                                willChangeDateH2S: f_willChangeDate(Number(setting.sensor_lifetime_h2s)),
                                willChangeDateTH: f_willChangeDate(Number(setting.sensor_lifetime_th)),
                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                            };

                            dispatch(registerDevice(body)).then(response => {
                                if (response.payload.registerSuccess) {
                                    let deviceInfo = response.payload.deviceInfo;
                                    add_msg = "[" + deviceInfo.sensorNumber + " (" + deviceInfo.id + ")] Node Sensor 추가 되었습니다.";
                                    alert(add_msg);
                                    window.location.replace('/Management');
                                }
                            });
                        }
                    });
                } else {
                    console.log("No Gateway...");
                }
            });
        } else {
            // 사용자가 'No'를 클릭한 경우
            console.log("Node Sensor Add Cancel...");
        }
    };

    const f_willChangeDate = (c_month) => {
        let today = new Date();
        let change_day = new Date();

        change_day.setMonth(today.getMonth() + c_month);

        let year = change_day.getFullYear();
        let month = ('0' + (change_day.getMonth() + 1)).slice(-2);
        let day = ('0' + change_day.getDate()).slice(-2);

        let change_date = year + '-' + month + '-' + day;

        return change_date;
    };

    // Node Sensor [-] 삭제 Modal
    const [deleteNodeInfo, setDeleteNodeInfo] = useState([]);
    const [deleteNodeSensorNumber, setDeleteNodeSensorNumber] = useState('');
    const [deleteNodeSensorId, setDeleteNodeSensorId] = useState('');

    const [deleteNodeSensorOpen, setDeleteNodeSensorOpen] = useState(false);

    useEffect(() => {
        console.log('deleteNodeInfo가 업데이트 되었습니다:', deleteNodeInfo);
    }, [deleteNodeInfo]);

    const handleDeleteNodeSensorOpen = (e) => {
        if (selectedIndex < 0) {
            alert_msg = "등록 리스트 페이지를 다시 로드해 주세요";
        }

        if (checkedList.length === 0) {
            alert_msg = "등록 리스트를 선택해주세요";
        } else if (checkedList.length !== 1) {
            alert_msg = "등록 리스트 중 하나만 선택해주세요";
        }
        if (alert_msg.length > 1) {
            alert(alert_msg);
            return;
        }

        const userInfo = userListInfo[selectedIndex];
        console.log('handleDeleteNodeSensorOpen:', userInfo);
        setDeleteNodeInfo(userInfo.sensorNode);
        console.log('handleDeleteNodeSensorOpen - deleteNodeInfo:', deleteNodeInfo);
        setSelectedGateway(userInfo.sensorMain);
        setCheckedNodeLists([]);
        setDeleteNodeSensorOpen(true);
    };
    const handleDeleteNodeSensorClose = () => setDeleteNodeSensorOpen(false);

    const [checkedNodeList, setCheckedNodeLists] = useState([]);
    const [selectedNodeIndex, setSelectedNodeIndex] = useState(-1);
    const onCheckedNodeElement = (checked, list, index) => {
        // alert(checked);

        if (checked) {
            setCheckedNodeLists([...checkedNodeList, list]);
            setSelectedNodeIndex(index);
        } else {
            // 체크 해제된 항목만 제거
            setCheckedNodeLists(prev => prev.filter(item => item !== list));
            // 선택 인덱스가 해제된 항목과 같다면 초기화
            setSelectedNodeIndex(prevIdx => prevIdx === index ? -1 : prevIdx);
        }
    };

    useEffect(() => {
        if (selectedNodeIndex > 0) {
            console.log('selectedNodeIndex가 업데이트 되었습니다:', selectedNodeIndex);
            console.log('deleteNodeInfo:', deleteNodeInfo);
            console.log('deleteNodeInfo[]:', deleteNodeInfo[selectedNodeIndex]);
            console.log('deleteNodeInfo[].value:', deleteNodeInfo[selectedNodeIndex].value);
            setDeleteNodeSensorNumber(deleteNodeInfo[selectedNodeIndex].value);
            setDeleteNodeSensorId(deleteNodeInfo[selectedNodeIndex].device);
        }
    }, [selectedNodeIndex]);

    useEffect(() => {
        console.log('deleteNodeSensor 정보가 업데이트 되었습니다:', deleteNodeSensorNumber, deleteNodeSensorId);
    }, [deleteNodeSensorNumber, deleteNodeSensorId]);

    const handleDeleteNodeSensor = (e) => {
        let delete_msg = "";
        const userInfo = userListInfo[selectedIndex];
        console.log('handleDeleteNodeSensor - userInfo:', userInfo);

        if (selectedNodeIndex < 0) {
            delete_msg = "삭제할 [Node Sensor]를 선택해주세요";
        }

        console.log('checkedNodeList:', checkedNodeList);
        if (checkedNodeList.length === 0) {
            delete_msg = "삭제할 [Node Sensor]를 선택해주세요";
        } else if (checkedNodeList.length !== 1) {
            delete_msg = "[Node Sensor]를 하나만 선택해주세요";
        }
        if (delete_msg.length > 1) {
            alert(delete_msg);
            return;
        }

        const confirmDelete = window.confirm("정말로 [Node Sensor]를 삭제하시겠습니까?");
        if (confirmDelete) {
            // 사용자가 'Yes'를 클릭한 경우, 추가 작업을 진행
            let body = {
                gateway: userInfo.sensorMain
            };

            console.log('findGateway', body);
            dispatch(findGateway(body)).then(response => {
                console.log(response);
                if (response.payload.findSuccess) {
                    let gateway = response.payload.userInfo;
                    let sensorNode = gateway.sensorNode;
                    console.log('sensorNode:', sensorNode);

                    let updatedSensorNode = sensorNode.filter(node => node.value !== deleteNodeSensorNumber);
                    console.log('Updated sensorNode:', updatedSensorNode);

                    body = {
                        gateway: userInfo.sensorMain,
                        sensorNode: updatedSensorNode
                    };

                    dispatch(updateGateway(body)).then(response => {
                        if (response.payload.updateSuccess) {
                            body = {
                                id: gateway.email,
                                sensorNumber: deleteNodeSensorNumber,
                                sensorId: deleteNodeSensorId
                            };
                            console.log('deleteDevice - body:', body);
                            dispatch(deleteDevice(body)).then(response => {
                                if (response.payload.deleteSuccess) {
                                    let deletedCount = response.payload.deletedCount;
                                    if (deletedCount > 0) {
                                        delete_msg = "[" + deleteNodeSensorNumber + " (" + deleteNodeSensorId + ")] Node Sensor 삭제 되었습니다.";
                                        alert(delete_msg);
                                        window.location.replace('/Management');
                                    }
                                }
                            });
                        }
                    });
                } else {
                    console.log("No Gateway...");
                }
            });
        } else {
            // 사용자가 'No'를 클릭한 경우
            console.log("Node Sensor Delete Cancel...");
        }
    };

    return (
        <div className="container">
            <div className="header-wrap">
                <div className="headerBtn">
                    <h1>등록 관리</h1>
                    <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '0px 32px', border: 'none', color:'white', marginLeft: '32px', fontSize: '16px'}} 
                            variant="outlined" href="/Registration">
                            신규 등록
                    </Button>
                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '0px 32px', border: 'none', color:'white', marginLeft: '16px', fontSize: '16px'}} 
                            variant="outlined" href="/RegistrationUser">
                            사용자 관리
                    </Button>
                </div>
                <div className="info-wrap">
                    <div className="info-id">
                        <span>{adminAccount.name}</span>
                        <button className="logout-btn" onClick={onLogoutHandler}>로그아웃</button>
                    </div>
                    <div className="info-email">
                        {adminAccount.email}
                    </div>
                </div>
            </div>

            <div className="bodyManagement">
                <div className="ManagementGrop1">
                    <div className="ManagementLayout">

                        <div className="setting-layout-header">
                            <h3>등록 리스트 및 관리</h3> <span>Registration list and management</span>
                        </div>
                        <div className="ManagementUserBody">
                            <div className="RegistrationSerch">
                                <input
                                    id="search"
                                    name="search"
                                    onChange={onChangeListSearch}
                                    className="textInput8"
                                    value={search.search}
                                    type="text"
                                    placeholder="상호 / 장비번호 / 아이디로 검색" />
                                <FontAwesomeIcon
                                    onClick={handleListSearch}
                                    icon={faMagnifyingGlass}
                                    style={{ color: '#130C0E', fontSize: '26px', cursor: 'pointer' }} />
                            </div>
                            <div className="RegistrationUserTable">
                                <ul className="ManagementTableTh">
                                    <li className="textSelect">선택</li>
                                    <li className="textSensor">장비 Part No.</li>
                                    <li className="textDate">등록일</li>
                                    <li className="textCompany">상호</li>
                                    <li>아이디</li>
                                    <li>전화번호</li>
                                    <li className="textAddress">주소</li>
                                    <li>담당자</li>
                                    <li>휴대폰 번호</li>
                                </ul>
                            {
                                userListInfo.map((user, index) => (
                                <ul className="RegistrationUserTd" key={user.email || index}>
                                    <li className="textSelect">
                                        <FormControl>
                                            <FormGroup
                                                id="listSelect"
                                                name="listSelect"
                                                value={index}
                                                onChange={(e) => onCheckedElement(e.target.checked, user, index)}
                                                checked={checkedList.includes(user) ? true : false}
                                                row
                                                aria-labelledby="list-row-radio-buttons-group-label"
                                            >
                                                <FormControlLabel value={index} control={<Checkbox />} label={index + 1} />
                                            </FormGroup>
                                        </FormControl>
                                    </li>
                                    <li className="textSensor">{user.sensorMain}</li>
                                    <li className="textDate">{user.registerDate}</li>
                                    <li className="textCompany">{user.company}</li>
                                    <li
                                        className="textID"
                                        onMouseMove={(e) => handleMouseMove(e, user.email)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        {user.email}
                                    </li>
                                    <li>{user.tel}</li>
                                    <li
                                        className="textAddress"
                                        onMouseMove={(e) => handleMouseMove(e, user.address)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        {user.address}
                                    </li>
                                    <li>{user.chargeName}</li>
                                    <li>{user.cellPhone1}</li>
                                </ul>
                                ))
                            }
                            {tooltip.visible && (
                                <div
                                    style={{
                                        position: "absolute",
                                        left: `${tooltip.x}px`,
                                        top: `${tooltip.y}px`,
                                        background: "#ffffff",
                                        color: "#333333",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd",
                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                        fontSize: "14px",
                                        whiteSpace: "normal",
                                        zIndex: 1000,
                                    }}
                                >
                                    {tooltip.content}
                                </div>
                            )}
                            </div>
                            <div className="ManagementBtn" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                {/* 왼쪽 정렬 버튼 그룹 */}
                                <div className="LeftButtons" style={{ display: 'flex', gap: '8px' }}>
                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', border: 'none', color:'white'}} 
                                            variant="outlined"
                                            onClick={handleAddNodeSensorOpen}
                                    >
                                            Sensor [+] 추가
                                    </Button>
                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', border: 'none', color:'white'}} 
                                            variant="outlined"
                                            onClick={handleDeleteNodeSensorOpen}
                                    >
                                            Sensor [-] 삭제
                                    </Button>
                                </div>

                                {/* 오른쪽 정렬 버튼 그룹 */}
                                <div className="RightButtons" style={{ display: 'flex', gap: '8px' }}>
                                    <CSVLink
                                        headers={headers}
                                        data={arrayPrints}
                                        target="_blank"
                                        filename={`등록_리스트_${moment().format('YYYYMMDD')}_${moment().format('HHMMSS')}`}
                                    >
                                        <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', marginRight: '8px', border: 'none', color: 'white'}}
                                                onClick={handlePrintSubmit}
                                                variant="outlined">
                                                출 력
                                        </Button>
                                    </CSVLink>
                                    <Button style={{backgroundColor: 'white', borderRadius:'8px', padding: '6px 32px', marginRight: '8px', color: 'red', borderColor: 'red'}}
                                            onClick={handleDeleteSubmit}
                                            variant="outlined">
                                            삭 제
                                    </Button>
                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', border: 'none', color:'white'}}
                                            onClick={handleModifyOpen}
                                            variant="outlined">
                                            수 정
                                    </Button>
                                </div>
                                <Modal
                                    open={modifyOpen}
                                    onClose={() => handleModifyClose(selectedIndex)}
                                    aria-labelledby="parent-modal-title"
                                    aria-describedby="parent-modal-description"
                                >
                                    <Box sx={{ ...style, width: 1280 }}>
                                        <Typography className="modalCloseIcon" component="div">
                                            <CloseIcon onClick={() => handleModifyClose(selectedIndex)} style={{marginTop: '50px'}} />
                                        </Typography>
                                        <Typography id="modal-modal-title" variant="h6" component="h2">
                                            등록 리스트 및 관리 수정
                                        </Typography>
                                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="div">
                                            <div className="RegistrationBody">
                                                <div className="textInputListFull">
                                                    <span className="listTitle">장비 Part No.</span>
                                                    <div className="sensorWrap">
                                                        <span className="sensor">
                                                            Gateway
                                                        </span>
                                                        <input
                                                            id="modifyMainSensor"
                                                            name="modifyMainSensor"
                                                            value={modifyMainSensor}
                                                            onChange={handleChangeModify}
                                                            disabled
                                                            ref={focusRefModifyMainSensor}
                                                            className="textInput5"
                                                            type="text"
                                                            placeholder="EMS01-GW-000001" />
                                                        {/* <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 32px', border: 'none', color:'#120C0E'}}
                                                                disabled
                                                                onClick={handleCheckDuplicate}
                                                                variant="outlined">
                                                                중복확인
                                                        </Button>
                                                    {
                                                        checkDuplicate &&
                                                        <Stack sx={{ width: '742px' }} spacing={2}>
                                                        {
                                                            existMainSensor &&
                                                            <Alert variant="outlined" severity="error" style={{ padding: '2px 16px', margin: '8px 0 0 16px' }}>
                                                                동일한 장비 Part No.입니다. 한번 더 확인해주세요.
                                                            </Alert>
                                                        }
                                                        {
                                                            !existMainSensor &&
                                                            <Alert variant="outlined" severity="success" style={{ padding: '2px 16px', margin: '8px 0 0 16px' }}>
                                                                장비 Part No. 중복확인 완료
                                                            </Alert>
                                                        }
                                                        </Stack>
                                                    } */}
                                                    </div>
                                                </div>
                                            {
                                                inputItems.map((item, index) => (
                                                <div className="textInputListFull" key={item.id || index}>
                                                    <span className="listTitle"></span>
                                                    <div className="sensorWrap">
                                                        <span className="sensor">
                                                            Node Sensor
                                                        </span>
                                                        <input
                                                            id={`modifyNodeSensor-${index}`}
                                                            name={`modifyNodeSensor-${index}`}
                                                            value={item.value}
                                                            onChange={(e) => handleChangeNodeSensor(e, index)}
                                                            disabled
                                                            // ref={item.id === index && focusRefModifyNodeSensor}
                                                            className="textInput5"
                                                            type="text"
                                                            placeholder="EMS01-NS-000001" />
                                                        <input
                                                            id={`modifyNodeSensorId-${index}`}
                                                            name={`modifyNodeSensorId-${index}`}
                                                            value={item.device}
                                                            onChange={(e) => handleChangeNodeSensorId(e, index)}
                                                            required
                                                            // ref={item.id === index && focusRefModifyNodeSensorId}
                                                            className="textInputId"
                                                            type="text"
                                                            maxLength={16} />
                                                        <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 36px', border: 'none', color:'#120C0E'}}
                                                                onClick={() => handleUpdateSensorId(index)}
                                                                variant="outlined">
                                                                ID 수정
                                                        </Button>
                                                    </div>
                                                </div>
                                                ))
                                            }
                                                <div className="textInputListFull2">
                                                    <span className="listTitle">측정 단위</span>
                                                    <div>
                                                        <div className="sensorWrap2">
                                                            <span className="subListText">
                                                                암모니아
                                                            </span>
                                                            <div className="Radio">
                                                                <FormControl>
                                                                    <RadioGroup
                                                                        id="modifyUnitNH3"
                                                                        name="modifyUnitNH3"
                                                                        value={modifyUnitNH3}
                                                                        onChange={handleChangeModify}
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                    >
                                                                        <FormControlLabel value="0" control={<Radio />} label="ppm" />
                                                                        <FormControlLabel value="1" control={<Radio />} label="ppb" />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </div>
                                                        </div>

                                                        <div className="sensorWrap2">
                                                            <span className="subListText">
                                                                황화수소
                                                            </span>
                                                            <div className="Radio">
                                                                <FormControl>
                                                                    <RadioGroup
                                                                        id="modifyUnitH2S"
                                                                        name="modifyUnitH2S"
                                                                        value={modifyUnitH2S}
                                                                        onChange={handleChangeModify}
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                    >
                                                                        <FormControlLabel value="0" control={<Radio />} label="ppm" />
                                                                        <FormControlLabel value="1" control={<Radio />} label="ppb" />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </div>
                                                        </div>

                                                        <div className="sensorWrap2">
                                                            <span className="subListText">
                                                                온도
                                                            </span>
                                                            <div className="Radio">
                                                                <FormControl>
                                                                    <RadioGroup
                                                                        id="modifyUnitTemperature"
                                                                        name="modifyUnitTemperature"
                                                                        value={modifyUnitTemperature}
                                                                        onChange={handleChangeModify}
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                    >
                                                                        <FormControlLabel value="0" control={<Radio />} label="℃" />
                                                                        &nbsp;&nbsp;&nbsp;
                                                                        <FormControlLabel value="1" control={<Radio />} label="℉" />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="textInputListFull2">
                                                    <span className="listTitle">센서 수명</span>
                                                    <div>
                                                        <div className="sensorWrap2">
                                                            <span className="subListText2">
                                                                암모니아
                                                            </span>
                                                            <input
                                                                id="modifyLifetimeNH3"
                                                                name="modifyLifetimeNH3"
                                                                value={modifyLifetimeNH3}
                                                                onChange={handleChangeModify}
                                                                required
                                                                ref={focusRefModifyLifetimeNH3}
                                                                className="textInput6"
                                                                type="text"
                                                                maxLength={2}
                                                                placeholder="00" />
                                                                개월
                                                        </div>

                                                        <div className="sensorWrap2">
                                                            <span className="subListText2">
                                                                황화수소
                                                            </span>
                                                            <input
                                                                id="modifyLifetimeH2S"
                                                                name="modifyLifetimeH2S"
                                                                value={modifyLifetimeH2S}
                                                                onChange={handleChangeModify}
                                                                required
                                                                ref={focusRefModifyLifetimeH2S}
                                                                className="textInput6"
                                                                type="text"
                                                                maxLength={2}
                                                                placeholder="00" />
                                                                개월
                                                        </div>

                                                        <div className="sensorWrap2">
                                                            <span className="subListText2">
                                                                온도
                                                            </span>
                                                            <input
                                                                id="modifyLifetimeTH"
                                                                name="modifyLifetimeTH"
                                                                value={modifyLifetimeTH}
                                                                onChange={handleChangeModify}
                                                                required
                                                                ref={focusRefModifyLifetimeTH}
                                                                className="textInput6"
                                                                type="text"
                                                                maxLength={2}
                                                                placeholder="00" />
                                                                개월
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="textInputListFull">
                                                    <span className="listTitle">아이디</span>                      
                                                    <input
                                                        id="modifyUserIdEmail"
                                                        name="modifyUserIdEmail"
                                                        value={modifyUserIdEmail}
                                                        onChange={handleChangeModify}
                                                        disabled
                                                        ref={focusRefModifyUserIdEmail}
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="아이디를 입력하세요" />
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">비밀번호</span>                      
                                                    <FormControl sx={{ width: '30%' }} variant="outlined">
                                                        <OutlinedInput
                                                            style={{ border: '1px', borderRadius: '8px', marginLeft: '16px', padding: '12px 12px 12px 2px',  height: '42px' }}
                                                            id="modifyUserPassword"
                                                            name="modifyUserPassword"
                                                            value={modifyUserPassword}
                                                            onChange={handleChangeModify}
                                                            inputRef={focusRefModifyUserPassword}
                                                            type={showModifyPassword ? 'text' : 'password'}
                                                            placeholder="비밀번호를 입력해주세요"
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        arial-label="toggle password visibility"
                                                                        onClick={handleClickShowModifyPassword}
                                                                        onMouseDown={handleMouseDownModifyPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showModifyPassword ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">비밀번호 확인</span>                      
                                                    <FormControl sx={{ width: '30%' }} variant="outlined">
                                                        <OutlinedInput
                                                            style={{ border: '1px', borderRadius: '8px', marginLeft: '16px', padding: '12px 12px 12px 2px',  height: '42px' }}
                                                            id="modifyUserPasswordConfirm"
                                                            name="modifyUserPasswordConfirm"
                                                            value={modifyUserPasswordConfirm}
                                                            onChange={handleChangeModify}
                                                            inputRef={focusRefModifyUserPasswordConfirm}
                                                            type={showModifyPasswordConfirm ? 'text' : 'password'}
                                                            placeholder="비밀번호를 한번 더 입력해주세요"
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        arial-label="toggle password visibility"
                                                                        onClick={handleClickShowModifyPasswordConfirm}
                                                                        onMouseDown={handleMouseDownModifyPasswordConfirm}
                                                                        edge="end"
                                                                    >
                                                                        {showModifyPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">상호</span>                      
                                                    <input
                                                        id="modifyUserCompany"
                                                        name="modifyUserCompany"
                                                        value={modifyUserCompany}
                                                        onChange={handleChangeModify}
                                                        required
                                                        ref={focusRefModifyUserCompany}
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="상호를 입력하세요" />
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">전화번호</span>                      
                                                    <input
                                                        id="modifyUserTel"
                                                        name="modifyUserTel"
                                                        value={modifyUserTel}
                                                        onChange={handleChangeModify}
                                                        required
                                                        ref={focusRefModifyUserTel}
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="전화번호를 입력하세요" />
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">주소</span>                      
                                                    <input
                                                        id="address"
                                                        name="address"
                                                        value={enroll_address.address === '' ? modifyUserAddress : enroll_address.address}
                                                        onChange={handleInput}
                                                        required
                                                        readOnly
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="주소를 입력하세요" />
                                                    <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 32px', border: 'none', color:'#120C0E'}}
                                                            onClick={handleComplete}
                                                            ref={focusRefModifyUserAddress}
                                                            variant="outlined">
                                                            주소검색
                                                    </Button>
                                                    {
                                                        popup &&
                                                        <Post address={enroll_address} setaddress={setEnroll_address} onClose={handleComplete}></Post>
                                                    }
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">상세주소</span>                      
                                                    <input
                                                        id="modifyUserAddressDetail"
                                                        name="modifyUserAddressDetail"
                                                        value={modifyUserAddressDetail}
                                                        onChange={handleChangeModify}
                                                        ref={focusRefModifyUserAddressDetail}
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="상세주소를 입력하세요" />
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">담당자</span>                      
                                                    <input
                                                        id="modifyUserChargeName"
                                                        name="modifyUserChargeName"
                                                        value={modifyUserChargeName}
                                                        onChange={handleChangeModify}
                                                        required
                                                        ref={focusRefModifyUserChargeName}
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="담당자 이름을 입력하세요" />
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">휴대폰 1</span>                      
                                                    <input
                                                        id="modifyUserCellPhone1"
                                                        name="modifyUserCellPhone1"
                                                        value={modifyUserCellPhone1}
                                                        onChange={handleChangeModify}
                                                        required
                                                        ref={focusRefModifyUserCellPhone1}
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="휴대폰 1을 입력하세요" />
                                                </div>
                                                <div className="textInputListFull">
                                                    <span className="listTitle">휴대폰 2</span>                      
                                                    <input
                                                        id="modifyUserCellPhone2"
                                                        name="modifyUserCellPhone2"
                                                        value={modifyUserCellPhone2}
                                                        onChange={handleChangeModify}
                                                        required
                                                        ref={focusRefModifyUserCellPhone2}
                                                        className="textInput7"
                                                        type="text"
                                                        placeholder="휴대폰 2를 입력하세요" />
                                                </div>
                                                <div>
                                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                                                            onClick={handleModifySubmit}
                                                            variant="outlined">
                                                            수 정
                                                    </Button>
                                                    <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}} 
                                                            onClick={handleModifyClose}
                                                            variant="outlined">
                                                            취 소
                                                    </Button>
                                                </div>
                                            </div>
                                        </Typography>                                 
                                    </Box>
                                </Modal>
                            </div>
                            {/* Sensor [+] 추가 Modal */}
                            <Modal
                                open={addNodeSensorOpen}
                                onClose={handleAddNodeSensorClose}
                                aria-labelledby="parent-modal-title"
                                aria-describedby="parent-modal-description"
                            >
                                <Box sx={{ ...style, width: 900, height: 400 }}>
                                    <Typography className="modalCloseIcon" component="div">
                                        <CloseIcon onClick={handleAddNodeSensorClose} style={{ marginTop: '0px' }} />
                                    </Typography>
                                    <Typography id="modal-modal-title" variant="h6" component="h1">
                                        Node Sensor [+] 추가
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 2 }} component="div">
                                        <div className="RegistrationBody">
                                            <div className="textInputListFull">
                                                <div className="sensorWrap">
                                                    <span className="sensor">Gateway</span>
                                                    <Select 
                                                        labelId="device-select-label"
                                                        value={selectedGateway} 
                                                        onChange={handleGatewayChange}
                                                        ref={focusRefGateway}
                                                        style={{ marginLeft: '46px', borderRadius: '8px' }}
                                                    >
                                                        <MenuItem
                                                            value={selectedGateway}
                                                            readOnly
                                                        >
                                                            {selectedGateway}
                                                        </MenuItem>
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="textInputListFull">
                                                <div className="sensorWrap">
                                                    <span className="sensor">Node Sensor</span>
                                                    <input
                                                        id={`addNodeSensorNumber`}
                                                        name={`addNodeSensorNumber`}
                                                        value={addNodeSensorNumber}
                                                        onChange={handleChangeAddNodeSensorNumber}
                                                        ref={focusRefAddNodeSensorNumber}
                                                        required
                                                        className="textInputId"
                                                        type="text"
                                                        maxLength={15}
                                                        placeholder="EMS01-NS-000001" />
                                                    <input
                                                        id={`addNodeSensorId`}
                                                        name={`addNodeSensorId`}
                                                        value={addNodeSensorId}
                                                        onChange={handleChangeAddNodeSensorId}
                                                        ref={focusRefAddNodeSensorId}
                                                        required
                                                        className="textInputId"
                                                        type="text"
                                                        maxLength={16} />
                                                    <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 32px', border: 'none', color:'#120C0E'}}
                                                            onClick={handleCheckNodeDuplicate}
                                                            variant="outlined">
                                                            중복확인
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="textInputListFull">
                                                <div className="sensorWrap">
                                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                                                            onClick={handleAddNodeSensor}
                                                            variant="outlined">
                                                            Node Sensor [+] 추가하기
                                                    </Button>
                                                    <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}} 
                                                            onClick={handleAddNodeSensorClose}
                                                            variant="outlined">
                                                            취 소
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Typography>                                 
                                </Box>
                            </Modal>
                            {/* Sensor [-] 삭제 Modal */}
                            <Modal
                                open={deleteNodeSensorOpen}
                                onClose={handleDeleteNodeSensorClose}
                                aria-labelledby="parent-modal-title"
                                aria-describedby="parent-modal-description"
                            >
                                <Box sx={{ ...style, width: 900, height: 600 }}>
                                    <Typography className="modalCloseIcon" component="div">
                                        <CloseIcon onClick={handleDeleteNodeSensorClose} style={{ marginTop: '0px' }} />
                                    </Typography>
                                    <Typography id="modal-modal-title" variant="h6" component="h1">
                                        Node Sensor [-] 삭제
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 2 }} component="div">
                                        <div className="RegistrationBody">
                                            <div className="textInputListFull">
                                                <div className="sensorWrap">
                                                    <span className="sensor">Gateway</span>
                                                    <Select 
                                                        labelId="device-select-label"
                                                        value={selectedGateway} 
                                                        onChange={handleGatewayChange}
                                                        ref={focusRefGateway}
                                                        style={{ marginLeft: '46px', borderRadius: '8px' }}
                                                    >
                                                        <MenuItem
                                                            value={selectedGateway}
                                                            readOnly
                                                        >
                                                            {selectedGateway}
                                                        </MenuItem>
                                                    </Select>
                                                </div>
                                            </div>
                                        {
                                            deleteNodeInfo.map((item, index) => (
                                            <div className="textInputListFull" key={item.id || index}>
                                                <div className="sensorWrap">
                                                    <span className="sensor">
                                                        Node Sensor
                                                    </span>
                                                    <input
                                                        id={`deleteNodeSensorNumber-${index}`}
                                                        name={`deleteNodeSensorNumber-${index}`}
                                                        value={item.value}
                                                        disabled
                                                        className="textInputId"
                                                        type="text"
                                                        maxLength={15}
                                                        placeholder="EMS01-NS-000001" />
                                                    <input
                                                        id={`deleteNodeSensorId-${index}`}
                                                        name={`deleteNodeSensorId-${index}`}
                                                        value={item.device}
                                                        disabled
                                                        className="textInputId"
                                                        type="text"
                                                        maxLength={16} />
                                                    <FormControl>
                                                        <FormGroup
                                                            id="deleteListSelect"
                                                            name="deleteListSelect"
                                                            value={index}
                                                            onChange={(e) => onCheckedNodeElement(e.target.checked, item, index)}
                                                            checked={checkedNodeList.includes(item) ? true : false}
                                                            row
                                                            aria-labelledby="list-row-radio-buttons-group-label"
                                                        >
                                                            <FormControlLabel value={index} control={<Checkbox />} label={index + 1} />
                                                        </FormGroup>
                                                    </FormControl>
                                                </div>
                                            </div>
                                            ))
                                        }
                                            <div className="textInputListFull">
                                                <div className="sensorWrap">
                                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                                                            onClick={handleDeleteNodeSensor}
                                                            variant="outlined">
                                                            Node Sensor [-] 삭제하기
                                                    </Button>
                                                    <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}} 
                                                            onClick={handleDeleteNodeSensorClose}
                                                            variant="outlined">
                                                            취 소
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Typography>                                 
                                </Box>
                            </Modal>
                            <div className="pagination">
                                <Pagination
                                    shape="rounded"
                                    count={LAST_PAGE}
                                    defaultPage={1}
                                    page={page}
                                    onChange={onPageHandler}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegistrationUser;
